import { AI_RECOMPOSE_MODE, GENERATION_GUIDANCE_TYPE } from '../generation';

export const BLOG_GUIDANCE_TYPE = {
  shorten: 'shorten',
  expand: 'expand',
  strict: 'strict',
  creative: 'creative',
  continueWriting: 'continueWriting',
  addExplanation: 'addExplanation',
  addExample: 'addExample',
  addList: 'addList',
  addConclusion: 'addConclusion',
  manualRewrite: 'manualRewrite',
};

const BLOG_GUIDANCE_TYPE_PROPS = {
  [BLOG_GUIDANCE_TYPE.continueWriting]: {
    label: 'Continue writing',
  },
  [BLOG_GUIDANCE_TYPE.addExplanation]: {
    label: 'Generate explanation',
  },
  [BLOG_GUIDANCE_TYPE.addExample]: {
    label: 'Generate example',
  },
  [BLOG_GUIDANCE_TYPE.addList]: {
    label: 'Add a list',
  },
  [BLOG_GUIDANCE_TYPE.addConclusion]: {
    label: 'Generate conclusion',
  },
  [BLOG_GUIDANCE_TYPE.shorten]: {
    label: 'Shorten',
  },
  [BLOG_GUIDANCE_TYPE.expand]: {
    label: 'Expand',
  },
  [BLOG_GUIDANCE_TYPE.strict]: {
    label: 'Keep similar to original',
  },
  [BLOG_GUIDANCE_TYPE.creative]: {
    label: 'Be creative',
  },
  [BLOG_GUIDANCE_TYPE.manualRewrite]: {
    label: 'Rewrite with instructions',
  },
};

export const getBlogGuidanceTypeLabel = (type) => {
  return BLOG_GUIDANCE_TYPE_PROPS[type]?.label || '';
};

const BLOG_GUIDANCE_TYPE_TO_GENERATION_GUIDANCE_TYPE = {
  [BLOG_GUIDANCE_TYPE.addExplanation]: GENERATION_GUIDANCE_TYPE.explain,
  [BLOG_GUIDANCE_TYPE.addExample]: GENERATION_GUIDANCE_TYPE.example,
  [BLOG_GUIDANCE_TYPE.addList]: GENERATION_GUIDANCE_TYPE.list,
  [BLOG_GUIDANCE_TYPE.addConclusion]: GENERATION_GUIDANCE_TYPE.conclusion,

  [BLOG_GUIDANCE_TYPE.shorten]: AI_RECOMPOSE_MODE.shorten, //need to add this to AI_RECOMPOSE_MODE
  [BLOG_GUIDANCE_TYPE.expand]: AI_RECOMPOSE_MODE.expand,
  [BLOG_GUIDANCE_TYPE.strict]: AI_RECOMPOSE_MODE.strict, // need to see what AC needs
  [BLOG_GUIDANCE_TYPE.creative]: AI_RECOMPOSE_MODE.refine, // need to see what AC needs
  [BLOG_GUIDANCE_TYPE.manualRewrite]: AI_RECOMPOSE_MODE.instructionBased,
};
export const blogGuidanceTypeToGenerationGuidanceType = (blogGuidanceType) =>
  BLOG_GUIDANCE_TYPE_TO_GENERATION_GUIDANCE_TYPE[blogGuidanceType];
